import src from "IMAGE";
export default { src, width: 1094, height: 243, blurWidth: 0, blurHeight: 0};
